import { isDelivery } from 'utils/service-mode';

import { IOnOrderStatusChangeOptions } from './types';

type OrderAndStatuses = 'orderStatus' | 'orderDeliveryStatus' | 'serverOrder';
type OrderStatusesAndPrevious = OrderAndStatuses | 'prevOrderStatus' | 'prevOrderDeliveryStatus';

const statusHasChanged = ({
  orderStatus,
  orderDeliveryStatus,
  prevOrderDeliveryStatus,
  prevOrderStatus,
  serverOrder,
}: Pick<IOnOrderStatusChangeOptions, OrderStatusesAndPrevious>) => {
  const isDeliveryOrder = isDelivery(serverOrder && serverOrder.cart.serviceMode);

  const posStatusHasChanged = orderStatus !== prevOrderStatus;
  const deliveryStatusHasChanged = orderDeliveryStatus !== prevOrderDeliveryStatus;

  return isDeliveryOrder ? posStatusHasChanged || deliveryStatusHasChanged : posStatusHasChanged;
};

export const handleOrderStatusChange = ({
  failure,
  logOrderLatency,
  logger,
  onSuccess,
  orderStatus,
  orderDeliveryStatus,
  prevOrderStatus,
  prevOrderDeliveryStatus,
  serverOrder,
  stopPolling,
  success,
}: IOnOrderStatusChangeOptions) => {
  if (!serverOrder) {
    return;
  }

  const orderStatusHasChanged = statusHasChanged({
    orderStatus,
    orderDeliveryStatus,
    prevOrderStatus,
    prevOrderDeliveryStatus,
    serverOrder,
  });

  if ((!success && !failure) || !orderStatusHasChanged) {
    return;
  }
  stopPolling();

  try {
    logOrderLatency(serverOrder);
  } catch (error) {
    logger.error({ error, message: 'Error logging order latency metric' });
  }

  if (success) {
    onSuccess(serverOrder);
  }
};
